import React, { useEffect, useState } from 'react';
import Tab from "../components/tab";
import { motion } from "framer-motion";
import { Typewriter } from "react-simple-typewriter";
import Footer from "../components/Footer";
import { useSelector, useDispatch } from "react-redux";
import {
  dispatchSkills,
  returnHome,
} from "../../../Redux/ActionCreator";
import { convertSkills } from "../../../Redux/convertResume";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { saveIntoServerCache, getOneFromServerCache } from "../../../utils/saveIntoCache";


const Skill1 = ({ nextStep, prevStep }) => {
  const dispatch = useDispatch();
  const flowLanguage = useSelector(e => e.t_lang.selected);
  const sidebar = useSelector(e => e.sidebarOpen.message);
  
  const Tech_skills = useSelector((e) => e.skills);
  const Personal_skills = useSelector((e) => e.p_skills);

  const [skills, setSkills]  = useState([]);

  const [selectedSkills, setSelectedSkills] = useState([]);

  const handleSkillClick = (skill) => {
    if (selectedSkills.includes(skill)) {
      setSelectedSkills(selectedSkills.filter(s => s !== skill));
    } else {
      if (selectedSkills?.length < 8) {
        setSelectedSkills([...selectedSkills, skill]);
      } else {
        setTimeout(() => {
          toast.error("You have reach maximum skills you can select", {
              position: toast.POSITION.TOP_RIGHT,
          });
        }, 50);
      }
    }
};


  const [showskills, setShowSkills] = useState(false);
  const [showButtomBTN, setShowButtomBTN] = useState(false);

  useEffect(() => {
    // Show first name label and input after delay (simulating onDone)
    const showSkillsTimeout = setTimeout(() => setShowSkills(true), 3500); // Matches Typewriter speed

    return () => clearTimeout(showSkillsTimeout);
  }, []);

  useEffect(() => {
    if (showskills == true) { // && selectedSkills?.length !== 0
      // Show first name label and input after delay (simulating onDone)
      const showButtomBTNTimeout = setTimeout(() => setShowButtomBTN(true), 500); // Matches Typewriter speed

      return () => clearTimeout(showButtomBTNTimeout);
    }
  }, [showskills, selectedSkills]);

  useEffect(() => {
    // dispatch(combine_skills(selectedSkills))
    // save into server cache
    let saveToCache = async () => {
      await saveIntoServerCache("technicalSkills", selectedSkills);
    }
    saveToCache();
  }, [selectedSkills])

  useEffect(() => {

    if (Tech_skills?.skills !== null) {
      let tSkills = [ ...new Set(Tech_skills?.skills)];
      // skills.push(...tSkills, ...pSkills);
      let displayedSkills = [...new Set([...tSkills])];
      let newSkills = [];
      if (displayedSkills?.length > 15) {
        newSkills = displayedSkills.slice(1, 16);
      } else {
        newSkills = displayedSkills;
      }
      console.log("New skills", newSkills);
      setSkills(prev => [ ...prev, ...newSkills]);
    } else {
      // console.log("skillsss", props.skills)
      let cacheInfo = getOneFromServerCache("technicalSkills")
      cacheInfo.then(res => res.json())
        .then(res => {
          // console.log("server cache value", res);
          if (res.success === true) {
            if (res.data !== null && res.data !== undefined) {
              let resObj = JSON.parse(res.data);
              // console.log("respObj", resObj);
              dispatch(dispatchSkills(resObj));
              setSkills(resObj?.slice(1, 16));
            }
            // console.log("Done");
          } else if (res.success === false && res.message == "Unauthorized") {
            dispatch(returnHome(res.status));
          }
        }).catch (error => console.log("Error prefilling the current experience company name and title", error))
    }
  }, []);

    /* Moving section */
    const handlePrev = () => {
        prevStep();
    }

    const handleNextCall = async () => {
        // handleNext(dispatch, firstName, lastName, nextStep);
        try {
            if (selectedSkills?.length !== 0) {
                dispatch(dispatchSkills(selectedSkills));
                // dispatch(combine_skills_loading());
                nextStep();
            } else {
            setTimeout(() => {
                toast.error("At least one skills is required", {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }, 50);
            }
        } catch (error) {
            throw error
        }
    }

  // console.log("skills", skills);
  return (
    <div className="bg-[#FAFAFA] px-4 md:px-6 lg:px-8 xl:px-10 py-8 w-full overflow-y-scroll ScrollOnly min-h-calc-70 flex justify-center lg:items-center">
      <div className={`${sidebar ? "sm:max-w-[65vw]" : "sm:max-w-[80vw]"} vsm:w-[90vw] gap-y-16 lg:gap-0 h-max lg:h-full bg-white flex flex-col lg:justify-between rounded-lg shadow-md py-10 px-6 md:px-8 md:py-8 `}>
        <div className="flex justify-between items-center mb-4">
          <div className="tabarea gap-x-4 items-center inline-flex flex-shrink-0 max-w-full overflow-hidden">
            <div className="vsm:hidden md:inline">
              <Tab
                label="Personal Information"
                current={false}
                completed={true}
                num="1"
              />
            </div>
            <div className="vsm:hidden md:inline">
              <Tab num="2" current={false} label="Experience" completed={true} />
            </div>
            <Tab num="3" current={true} label="Skills" completed={false} />
            <Tab num="4" current={false} label="Language" completed={false} />
            <Tab num="4" current={false} label="Education" completed={false} />
            <Tab num="5" current={false} label="Professional Summary" completed={false} />
          </div>
        </div>
        <h2 className="text-xl text-center font-semibold mb-4 notranslate">
          {flowLanguage == "Spanish" ? (
            <Typewriter key={flowLanguage} words={["Hemos creado una lista de habilidades técnicas en tu experiencia anterior. Por favor, selecciona algunas de las habilidades a continuación."]} loop={1} typeSpeed={40} />
          ) : (
            <Typewriter key={flowLanguage} words={["We have created a list of job-specific from your previous experience, kindly select a few from the skills below."]} loop={1} typeSpeed={40} />
          )}
          {/* <Typewriter words={["We have created a list of job-specific and soft skills from your previous experience, kindly select a few from the skills below."]} loop={1} typeSpeed={40} /> */}
          </h2>
        <p className="text-gray-600 mb-6 notranslate">
          {flowLanguage == "Spanish" ? (
            <Typewriter key={flowLanguage} words={["Haz clic en una habilidad para seleccionarla."]} loop={1} typeSpeed={40} />
          ) : (
            <Typewriter key={flowLanguage} words={["Click on a skill to select it."]} loop={1} typeSpeed={40} />
          )}
          {/* <Typewriter words={["Click on a skill to select it."]} loop={1} typeSpeed={40} /> */}
        </p>
        {showskills && (
          <motion.div 
            initial={{ opacity: 0, y: 30 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.8 }} 
              className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-6"
          >
            {skills?.map((skill, index) => (
              <button
                key={index}
                className={`p-4 rounded-md text-center ${selectedSkills.includes(skill) ? 'bg-black text-white' : 'bg-gray-200'}`}
                onClick={() => handleSkillClick(skill)}
              >
                {skill}
              </button>
            ))}
          </motion.div>
        )}

        {/* Navigation Buttons */}

        {/* Navigation Buttons */}
        <div className="flex justify-center w-full">
          {showButtomBTN && (
              <motion.div 
                initial={{ opacity: 0, y: 30 }} 
                animate={{ opacity: 1, y: 0 }} 
                transition={{ duration: 0.8, ease: "easeOut", delay: 1.4 }}
                className="flex justify-between lg:max-w-[90%] w-full">
                  <button
                      onClick={handlePrev}
                      className="border-[#FF6633] border flex items-center gap-x-3 text-black font-medium py-4 vsm:px-6 px-8 rounded-md"
                  >
                      <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1.5 8.99891L9.5 16.3789" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M1.5 9L9.5 1.62" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      <span className="notranslate" key={flowLanguage}>
                        {flowLanguage == "Spanish" ? (
                          "ANTERIOR"
                        ) : (
                          "PREVIOUS"
                        )}
                      </span>
                  </button>
                  
                  <button
                      onClick={handleNextCall}
                      className="bg-[#5843BD] flex items-center gap-x-3 text-white font-medium py-3 vsm:px-4 px-6 rounded-md"
                  >
                    <span className="notranslate" key={flowLanguage}>
                      {flowLanguage == "Spanish" ? (
                        "GUARDAR"
                      ) : (
                        "SAVE"
                      )}
                    </span>
                      <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.5 8.99891L1.5 16.3789" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M9.5 9L1.5 1.62" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                  </button>

              </motion.div>
            )}
          </div>

      </div>
      <ToastContainer />
    </div>
  );
};

export default Skill1;
